import { render, staticRenderFns } from "./Wir.vue?vue&type=template&id=53d42368"
import script from "./Wir.vue?vue&type=script&lang=js"
export * from "./Wir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports